// Re-export from canonical location: components/ui/v2/sidebar
export * from "components/ui/v2/sidebar/sidebar-icon-modules-path";
